import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import ContactDetail from '../Contacts/ContactDetail';
import FileDescriptor from '../FileDescriptor';

export default class LetterAuthorisationSignatory extends TemporalEntity {
    static typeName = "LetterAuthorisationSignatory";

    constructor() {
        super();
        this.makeObservable();
    }

    public letterAuthorisationSignatoryId: number = 0;

    @Attributes.ChildObject(ContactDetail, true)
    public contactDetail: ContactDetail = new ContactDetail();

    @Rules.Required("Image is required")
    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public imageFileDescriptorId: number | null = null;

    @Attributes.ChildObject(FileDescriptor)
    public imageFileDescriptor: FileDescriptor | null = null;

    @Rules.StringLength(100)
    public userName: string | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public hasSigned: boolean = false;

    @Attributes.NoTracking()
    public allowedToSign: boolean = false;

    @Attributes.DisplayMember()
    public get display() {
        return this.contactDetail.fullName;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New letter authorisation signatory";
        } else {
            return "Letter Authorisation Signatory";
        }
    }
}